import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "title", "children"];
var __jsx = React.createElement;
/* eslint-disable react/no-danger */
import React from "react";
import MUITooltip from "@mui/material/Tooltip";
var ELSTooltip = function ELSTooltip(_ref) {
  var className = _ref.className,
    title = _ref.title,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!title) {
    return children;
  }
  var holdTitle = title.toString().replace(/(<([^>]+)>)/gi, "").toString().replace(/^\*/, "");
  return /*#__PURE__*/React.createElement(MUITooltip, _extends({
    className: "es-tooltip ".concat(className || ""),
    title: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: holdTitle
      }
    })
  }, props), children);
};
export { ELSTooltip };